<template>

  <section class='how-to-take bg-white'>
    <div class='lightblue-bg'>
      <div class='wrapper'>
        <b-container>
          <b-row>
            <b-col class=''>
              <div class='contents mx-auto text-center'>
                <h2>How to take JORNAY PM.</h2>
                <hr>

                <p class='dark-text'>
                  <em class='main-text fw-extrabold'>Choose a time to take once nightly</em>
                  JORNAY PM starts working about 10 hours after it is taken. It’s recommended to take <span
                    class='text-nowrap'>JORNAY PM</span>
                  between
                  <span class='text-nowrap'>6:30 PM</span>
                  and <span class='text-nowrap'>9:30 PM.</span> You should work with your healthcare provider to choose a time to take <span
                    class='text-nowrap'>JORNAY PM</span>. If
                  evening
                  activities are planned, take your dose with you.
                </p>

                <p class='dark-text'>
                  <em class='main-text fw-extrabold'>Create a reminder for <span class='text-nowrap'>JORNAY PM</span></em>
                  JORNAY PM should be taken at the same time every evening. Set an alarm on your phone or your child’s
                  phone.
                  Placing a reminder in an area where it will be seen can also be helpful.
                </p>

                <p class='dark-text'>
                  <em class='main-text fw-extrabold'>With or without food</em>
                  JORNAY PM should be taken at the same time every evening. It can be taken with or without
                  food,&nbsp;but
                  it
                  should
                  be taken the same way every time.
                </p>

                <p class='dark-text'>
                  <em class='main-text fw-extrabold'>Trouble swallowing a capsule?</em>
                  If your child is unable to swallow the whole capsule, it can be opened and sprinkled on applesauce. Your
                  child should swallow all the applesauce and medicine right&nbsp;away. <br>
                  The JORNAY PM capsule and its contents should not be divided or&nbsp;chewed.
                </p>

                <p class='dark-text'>
                  <em class='main-text fw-extrabold'>What happens if you miss a dose?</em>
                  You should talk to your healthcare provider about what to do if a dose is missed in the evening.
                  If&nbsp;you
                  miss
                  a regular dose time, <span class='text-nowrap'>JORNAY PM</span> should be taken as soon as it’s remembered
                  in the evening. If it’s
                  not
                  remembered until the next day, skip the dose and wait until that evening.
                </p>

                <p class='fw-extrabold main-text pb-2 pb-lg-0 pt-5 mt-md-3'>JORNAY PM should not be taken in the morning. Talk to
                  your doctor if you have any questions about taking <span class='text-nowrap'>JORNAY PM</span>.</p>

              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HowToTake'
}
</script>
